import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import MainHeading from "../../../components/comman/MainHeading";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { formatAmount } from "../../../utility/CommonFunctions";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import PaginationComponent from "../../../components/comman/PaginationComponent";
import { Spinner } from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useSelector } from "react-redux";
import DayBookIcon from "../../../components/Icons/DayBookIcon";

export default function DayBook() {
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: "",
    sortByDate: [
      moment().subtract(30, "days").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    year: "",
    transactionData: [],
    countsData: {},
    companyList: [],
    companyId: "",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });
  const [activeTab, setActiveTab] = useState({
    creditTab: false,
    debitTab: false,
  });
  const userDetails = useSelector((state) => state.root.userDetails);
  // console.log("countsData====>", pageStates?.countsData);

  useEffect(() => {
    if (pageStates?.year) {
      GetTransactionData();
    }
  }, [
    pageStates?.currentPage,
    pageStates?.searchQuery,
    pageStates?.pageSize,
    pageStates?.sortByDate,
    pageStates?.year,
    pageStates?.companyId,
    pageStates?.siteId,
    activeTab,
    pageStates?.isInitial,
  ]);

  useEffect(() => {
    GetCompanyList();
    GetSiteList();
  }, []);

  const GetTransactionData = (pageNo) => {
    let options = {
      method: "GET",
    };
    const typeParam = activeTab?.creditTab
      ? "type=credit&"
      : activeTab?.debitTab
        ? "type=debit&"
        : "";

    const Url = `${apiUrl.get_transaction
      }?from=cashBook&${typeParam}${MainFilterHandler(pageStates)}`;

    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          transactionData: res?.data?.transaction,
          countsData: { ...res?.data?.counts },
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        name: "",
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    setPageStates((pre) => ({
      ...pre,
      ...(type === "site" && { siteId: data?.site }),
      ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
    }));
  };

  const handleYearChange = (selectedYear) => {
    setPageStates((prev) => ({
      ...prev,
      year: selectedYear,
      sortByDate: isFirstYearChange ? prev.sortByDate : [],
    }));

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Day Book"}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
          handleYearChange={handleYearChange}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              filterArray={sortList}
              handleData={handleSortData}
              pageStates={pageStates}
              getSite={GetSiteList}
              getCompany={GetCompanyList}
            />
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h3 className="card-title d-flex align-items-center gap-3">
                <span className="d-flex align-items-center justify-content-center p-3 rounded-circle bg-white border border-dark">
                  <DayBookIcon />
                </span>
                Day Book Entries
              </h3>
              <div className="d-flex gap-3  align-items-center justify-content-between text-center">
                <p
                  className={
                    pageStates?.countsData?.netAmount === 0
                      ? "text-warning mb-0 fw-semibold"
                      : pageStates?.countsData?.netAmount > 0
                        ? "text-success mb-0 fw-semibold"
                        : "text-danger mb-0 fw-semibold"
                  }
                >
                  <span className="text-muted">Net Amount : </span>
                  {formatAmount(pageStates?.countsData?.netAmount || 0)}
                </p>
              </div>
            </div>
            <div className="d-flex gap-3 mb-3 align-items-center justify-content-between text-center">
              <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center">
                <h5 className="m-0 fw-semibold">
                  {pageStates?.countsData?.totalEntries} Entries
                </h5>
              </div>
              <div
                style={{ cursor: "pointer" }}
                className={`d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center 
  ${activeTab?.creditTab ? "border border-success border-2 cursor-pointer" : ""
                  }`}
                onClick={() =>
                  setActiveTab((prev) => ({
                    ...prev,
                    creditTab: !activeTab?.creditTab,
                    debitTab: false,
                  }))
                }
              >
                <h5 className="m-0 text-success fw-semibold">
                  {formatAmount(pageStates?.countsData?.creditAmount || 0)}{" "}
                </h5>
              </div>
              <div
                style={{ cursor: "pointer" }}
                className={`d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-center 
  ${activeTab?.debitTab ? "border border-danger border-2 cursor-pointer" : ""}`}
                onClick={() =>
                  setActiveTab((prev) => ({
                    ...prev,
                    debitTab: !activeTab?.debitTab,
                    creditTab: false,
                  }))
                }
              >
                <h5 className="m-0 text-danger fw-semibold">
                  {formatAmount(pageStates?.countsData?.debitAmount || 0)}
                </h5>
              </div>
            </div>

            <div className="ledgers">
              {pageStates?.tableLoader ? (
                <div className="d-flex justify-content-center my-5 ">
                  <Spinner />
                </div>
              ) : pageStates?.transactionData?.length > 0 ? (
                pageStates?.transactionData
                  ?.slice()
                  .reverse()
                  ?.map((item, index) => {
                    const isInvoice = item?.invoice !== null;
                    const isVoucher = item?.Voucher !== null;

                    // Unified source
                    const data = isInvoice ? item?.invoice : item?.Voucher;
                    const remark = isInvoice
                      ? data?.remark
                      : item?.Voucher?.remark;

                    const transactionOrVoucherNumber = isInvoice
                      ? `Trans. No. - ${item?.transactionId} (${data?.invoiceNumber})`
                      : `Payment Advisory No. - ${data?.voucherNumber} (${item?.paymentticket?.ticketNumber || ""
                      } ${item?.paymentticket?.type
                        ? `, ${item?.paymentticket?.type}`
                        : ""
                      })`;

                    const vendorName = !isInvoice &&
                      item?.paymentticket?.type !== "General" && (
                        <p className="time text-muted mb-0 mt-0">
                          Vendor Name -{" "}
                          {data?.paymentticket?.purchase?.vendor?.name || "--"}
                        </p>
                      );

                    return (
                      <div key={item.id}>
                        {!item?.isOpeningBalance && (
                          <div className="ledger">
                            <span className="icon px-2 py-2">
                              <span className="fs-5 fw-bold">{moment(item?.createdAt).date()}</span>
                              <p className="fs-6 m-0">
                                {moment(item?.createdAt).format("MMM")}
                              </p>
                            </span>

                            <div>
                              <p className="time text-muted mb-0">
                                Trans. Date -{" "}
                                {moment(item?.transactionDate).format(
                                  "DD/MM/YYYY"
                                )}
                              </p>

                              {data && (
                                <p className="time mb-0 mt-0 fw-bold">
                                  {transactionOrVoucherNumber}
                                </p>
                              )}

                              {vendorName}

                              <p className="time text-muted mb-0 mt-0">
                                Created By - {item?.user?.name} (
                                {item?.user?.designation?.name} -{" "}
                                {item?.user?.department?.name},{" "}
                                {item?.site?.name} )
                              </p>
                              <p className="time text-muted mb-0 mt-0">
                                Payment Method - {item?.paymentMethod}
                              </p>
                              <p className="time text-muted mb-0 mt-0">
                                {(item?.paymentMethod === "NEFT" ||
                                  item?.paymentMethod === "RTGS" ||
                                  item?.paymentMethod === "IMPS") &&
                                  `(AC. Holder Name. - ${item?.accountHolderName})  `}
                                {item?.paymentMethod === "Cash" &&
                                  `(Reference Name. - ${item?.referenceName})  `}
                                {item?.paymentMethod !== "Cash"
                                  ? `(UTR No. - ${item?.utr})  `
                                  : ""}
                                {(item?.paymentMethod === "NEFT" ||
                                  item?.paymentMethod === "RTGS" ||
                                  item?.paymentMethod === "IMPS") &&
                                  `(Bank Name. - ${item?.bankName})  `}
                                {(item?.paymentMethod === "NEFT" ||
                                  item?.paymentMethod === "RTGS" ||
                                  item?.paymentMethod === "IMPS") &&
                                  `(AC. No. - ${item?.accountNumber})  `}
                              </p>
                            </div>

                            <h5
                              className={
                                item?.type === "credit"
                                  ? "text-success mb-0 ms-auto fw-semibold"
                                  : "text-danger mb-0 ms-auto fw-semibold"
                              }
                            >
                              {formatAmount(item?.amount || "--")}
                            </h5>

                            <p className="time text-muted m-0 text-center">
                              Remark
                            </p>
                            <p className="time text-muted m-0 remark">
                              {remark || "--"}
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })
              ) : (
                <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                  <NoRecordIcon />
                  {"No record found"}
                </div>
              )}
            </div>

            <div className="d-flex justify-content-between align-items-center pt-3 mt-3 border-top">
              <div className="d-flex align-items-center gap-2">
                {pageStates?.count > 0 && !pageStates?.tableLoader && (
                  <div className="dropdown short">
                    <button
                      className="btn dropdown-toggle border"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {pageStates?.pageSize}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M6.40039 8.19922L10.0004 11.7992L13.6004 8.19922"
                            stroke="#36394A"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                      </span>
                    </button>
                    <ul className="dropdown-menu ">
                      {[10, 20, 30, 40, 50].map((value) => (
                        <li key={value}>
                          <button
                            className={`dropdown-item ${pageStates?.pageSize === value && "active"
                              }`}
                            onClick={() => handleChangePageSize(value)}
                          >
                            {value}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div>
                  {pageStates?.count > 0 && !pageStates?.tableLoader && (
                    <p
                      className="mb-0 text-muted fw-medium text-uppercase"
                      style={{ fontSize: "10px" }}
                    >
                      {`Showing ${pageStates?.currentPage * pageStates?.pageSize -
                        (pageStates?.pageSize - 1)
                        } to ${pageStates?.currentPage * pageStates?.pageSize <
                          pageStates?.count
                          ? pageStates?.currentPage * pageStates?.pageSize
                          : pageStates?.count
                        } of ${pageStates?.count} entries`}
                    </p>
                  )}
                </div>
              </div>

              <PaginationComponent
                currentPage={pageStates?.currentPage}
                PageChangeHandler={PageChangeHandler}
                totalPages={pageStates?.totalPages}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
